var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "results-wrapper"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h1', [_vm._v("\n      " + _vm._s(_vm.motivational) + "\n      "), _c('span')])]), _c('div', {
    staticClass: "chart",
    style: {
      backgroundImage: 'url(' + _vm.spotCheckBg + '), none'
    }
  }, [_c('div', {
    staticClass: "stats-container"
  }, [_c('h2', {
    staticClass: "spotCheckType"
  }, [_vm._v(_vm._s(_vm.spotCheckType))]), _c('ul', {
    staticClass: "stats"
  }, [_c('li', {
    staticClass: "category"
  }, [_c('span', [_vm._v("Time: ")]), _c('span', {
    staticClass: "category-spacer"
  }, [_vm._v("\n            " + _vm._s(_vm.result.min) + "\n            "), _c('span', {
    staticClass: "statsValueDecorator"
  }, [_vm._v("min")]), _vm._v("\n            " + _vm._s(_vm.result.sec) + "\n            "), _c('span', {
    staticClass: "statsValueDecorator"
  }, [_vm._v("sec")])])]), _c('li', {
    staticClass: "category smaller"
  }, [_c('span', {
    staticClass: "smaller"
  }, [_vm._v("\n            " + _vm._s(_vm.perMinuteLabel) + ":\n            "), _c('span', [_vm._v("(" + _vm._s(_vm.perMinuteLabelAbbreviation) + ")")])]), _c('span', [_vm._v("\n            " + _vm._s(_vm.result.wpm) + "\n          ")])]), _c('li', {
    staticClass: "category"
  }, [_c('span', [_vm._v("Errors: ")]), _c('span', [_vm._v("\n            " + _vm._s(_vm.result.numErr) + "\n          ")])]), _c('li', {
    staticClass: "category"
  }, [_c('span', [_vm._v("Accuracy: ")]), _c('span', [_vm._v(_vm._s(_vm.result.accuracy) + "%")])])]), _c('h2', {
    staticClass: "myBestTitle"
  }, [_vm._v("My Best")]), _c('ul', {
    staticClass: "myBest"
  }, [_c('li', [_c('span', {
    staticClass: "ribbon",
    class: {
      show: _vm.result.isNewBest
    },
    style: {
      backgroundImage: 'url(' + _vm.ribbon + '), none'
    }
  }), _c('span', {
    staticClass: "newBest",
    class: {
      show: _vm.result.isNewBest
    }
  }, [_vm._v("NEW BEST!")])]), _c('li', [_c('span', {
    staticClass: "heading"
  }, [_vm._v(_vm._s(_vm.perMinuteLabel))]), _c('span', {
    staticClass: "bestWpm"
  }, [_vm._v(_vm._s(_vm.result.bestResultsWPM))])]), _c('li', [_c('span', {
    staticClass: "heading"
  }, [_vm._v("Accuracy")]), _c('span', {
    staticClass: "bestAccuracy"
  }, [_vm._v(_vm._s(_vm.result.bestResultsAccuracy) + "%")])])])])]), _c('div', {
    staticClass: "spotCheckNext"
  }, [_vm.showRetryBtn ? _c('button', {
    staticClass: "spotCheckButton pure-button",
    on: {
      "click": _vm.redoSpotCheck
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.svgTryAgain)
    }
  }), _c('span', [_vm._v("Try Again")])]) : _vm._e(), _vm.kwtMode !== 'preview' ? _c('button', {
    staticClass: "spotCheckButton pure-button",
    staticStyle: {
      "margin-left": "210px"
    },
    on: {
      "click": _vm.continueCurriculum
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.svgQuit)
    }
  }), _c('span', [_vm._v("Skip Ahead")])]) : _vm._e()])]);
}
var staticRenderFns = []

export { render, staticRenderFns }